export const environment = {
  production: false,
  baseUrl: 'https://project-dashboard-api.onrender.com'
};
